/**
 * Bank Account Domain Types
 * Defines types for bank account management
 */
/**
 * Interest calculation method options for UI
 */
export const INTEREST_CALCULATION_METHODS = [
    { value: 'daily', labelKey: 'account.interest.method.daily' },
    { value: 'biweekly_strict', labelKey: 'account.interest.method.biweeklyStrict' },
    { value: 'biweekly_simple', labelKey: 'account.interest.method.biweeklySimple' },
];
/**
 * Interest payment frequency options for UI
 */
export const INTEREST_PAYMENT_FREQUENCIES = [
    { value: 'monthly', labelKey: 'account.interest.frequency.monthly' },
    { value: 'quarterly', labelKey: 'account.interest.frequency.quarterly' },
    { value: 'annually', labelKey: 'account.interest.frequency.annually' },
];
//# sourceMappingURL=account.js.map